"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padNumber = void 0;
/**
 * dodaje widoące zera do liczby
 * @param value liczba
 * @param minLength minimalna, wynikowa długośc tekstu, domyslnie 2
 */
function padNumber(value, minLength) {
    if (minLength === void 0) { minLength = 2; }
    // przyspieszenie dla najczęstszego przypadku
    if (minLength === 2) {
        if (value < 10) {
            return '0' + value;
        }
        else {
            return '' + value;
        }
    }
    var result = '' + value;
    while (result.length < minLength) {
        result = '0' + result;
    }
    return result;
}
exports.padNumber = padNumber;
exports.default = padNumber;
//# sourceMappingURL=padNumber.js.map